<template>
    <div class="container-fluid">
        <nav>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item"><router-link to="/admin/tickets">お問い合わせ管理</router-link></li>
                <li class="breadcrumb-item">お問い合わせ（管理者）</li>
            </ol>
        </nav>
        <div class="container">
            <div class="form-ticket" v-if="ticket.id">
                <div class="mb-3">
                    <div class="param ticket-title d-flex justify-content-start">
                        <div>
                            チケットID: {{ticket.id}}
                            <h4>{{ticket.ticket_subject.subject}}</h4>
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <label>お問い合わせ内容</label>
                    <editor :content="$filters.jsonParse(ticket.topic)"
                        :readOnly="true"
                        ref="ticket-viewer"
                        :minHeight="0"
                        class="param"></editor>
                </div>
                <div class="mb-3 small d-flex justify-content-end">
                    <div class="mr-3">
                        {{ticket.user.name}}
                        <span class="badge badge-secondary badge-pill" v-if="ticket.closed_at">
                            {{$filters.fromNow(ticket.closed_at )}} にクローズ
                        </span>
                    </div>
                    <div>
                        {{ $filters.dateFormat(ticket.created_at) }}
                    </div>
                </div>
                <div class="mb-3 text-center">
                    <button type="button" class="btn btn-sm"
                        :class="{
                            'btn-outline-danger': !ticket.closed_at,
                            'btn-outline-success': ticket.closed_at,
                        }"
                        @click="toggleTicket()">
                        <span v-if="!ticket.closed_at">チケットをクローズする</span>
                        <span v-else>チケットを再オープンする</span>
                    </button>
                </div>
            </div>

            <hr>

            <div class="form-ticket" v-if="ticket.id && !ticket.closed_at">
                <div class="mb-3">
                    <label>
                        返信
                    </label>
                    <editor :content="$filters.jsonParse(ticket_topic.topic)"
                        ref="topic_editor"
                        id="topic-editor"
                        :minHeight="100"
                        @saved="topicSaved($event)"
                        class=""></editor>
                </div>
                <div class="mb-3">
                    <editor-storage
                        :content="ticket_topic.topic"
                        :max="2097152"></editor-storage>
                </div>
                <div class="mb-3">
                    <button type="button" class="btn btn-outline-primary btn-sm" @click="saveTopic()">
                        <i class="fas fa-check"></i>
                        返信
                    </button>
                </div>
            </div>
            <div class="form-ticket" v-if="ticket.id">
                <div class="card my-4" v-for="t in ticket.ticket_topics" :key="t.id">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <span>
                            {{t.user.name}}
                            <span class="badge badge-danger badge-pill" v-if="t.user.is_root">管理者</span>
                        </span>

                        <div>
                            <span class="text-muted small" title="t.created_at">
                                {{$filters.dateFormat(t.created_at )}}
                            </span>
                            <button type="button" class="close ml-2" aria-label="Close" v-if="t.user.id == $store.state.user.id" @click="remove(t)">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <editor :content="$filters.jsonParse(t.topic)"
                            :id="'editor-' + t.id"
                            :readOnly="true"
                            :minHeight="0"></editor>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.form-ticket {
    margin: 1rem auto;
}
.param {
    padding: 1rem;
    border: 3px solid #ddd;
    border-radius: .7rem;
}
.ticket-title {
    padding: 1rem 65px;
}
</style>

<script>
export default {
    data() {
        return {
            ticket: {
                topic: "",
                ticket_topics: [],
            },
            is_edit: false,
            ticket_topic: {
                topic: "",
                ticket_id: null,
            },
        }
    },
    methods: {
        load() {
            axios.get("/admin/ticket/get", {params: {id: this.$route.params.id}}).then(res => {
                this.ticket = res.data;
            }).catch(err => { alert.err(err.response) });
        },
        async saveTopic() {
            this.ticket_topic.ticket_id = this.ticket.id;
            const saved_data = await this.$refs.topic_editor.save();
            this.ticket_topic.topic = JSON.stringify(saved_data);
            axios.post("/admin/ticket/topic/save", this.ticket_topic).then(res => {
                alert.msg(res.data);
                this.ticket_topic.topic = "";
                this.$refs.topic_editor.refresh();
                this.load();
            }).catch(err => { alert.err(err.response) });
        },
        remove(t) {
            Swal.fire({
                title: "トピックの削除",
                html: `<div class="text-left">
                    指定のトピックを削除します。<br/>
                    よろしいですか？</div>
                `,
                icon: "error",
                showCancelButton: true,
                confirmButtonColor: "crimson",
                cancelButtonColor: "gray",
                confirmButtonText: "削除",
                cancelButtonText: "キャンセル",
                reverseButtons: true,
            }).then(confirm => {
                if (confirm.isConfirmed) {
                    axios.post("/admin/ticket/remove", {id: t.id}).then(res => {
                        alert.msg(res.data);
                        this.load();
                    }).catch(err => { alert.err(err.response) });
                }
            });
        },
        toggleTicket() {
            axios.post("/admin/ticket/toggle", {id: this.ticket.id}).then(res => {
                alert.msg(res.data);
                this.load();
            }).catch(err => { alert.err(err.response) });
        },
        topicSaved(ev) {
            this.ticket_topic.topic = JSON.stringify(ev);
        },
        ticketSaved(ev) {
            this.ticket.topic = JSON.stringify(ev);
        },
    },
    computed: {
        placeholder() {
            const s = _.find(this.ticket_subjects, {id: this.ticket.ticket_subject_id});
            if (s) {
                return s.description;
            }
            return "種別を選んでください。";
        }
    },
    mounted() {
        this.load();
    }
}
</script>